var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E9F0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H19V11H11V19ZM13 13H17V17H13V13Z",
    fill: "#2990FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H19V21H11V29ZM13 23H17V27H13V23Z",
    fill: "#2990FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11V19H29V11H21ZM27 17H23V13H27V17Z",
    fill: "#2990FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27H27V29H29V27Z",
    fill: "#2990FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21H21V23H23V21Z",
    fill: "#2990FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H23V25H25V23Z",
    fill: "#2990FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25H21V27H23V25Z",
    fill: "#2990FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 27H23V29H25V27Z",
    fill: "#2990FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25H25V27H27V25Z",
    fill: "#2990FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21H25V23H27V21Z",
    fill: "#2990FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23H27V25H29V23Z",
    fill: "#2990FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.ce03438b32b54cb6d802c250ba4ba3b6.svg";
export { ForwardRef as ReactComponent };